module.exports = "https://r.nearpod.com/assets/media/image/beta-label-dc4dc9d2946206bb51af3539995870b4.svg";